// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Розширення Visual Studio Code» (Visual Studio Code Extensions, ключ `vsc`, група `meta`). */
export const visualStudioCodeExtensionsManifest: IModuleManifest = {
  key: 'vsc',
  group: 'meta',
  slug: 'visual-studio-code-extensions',
  prefix: 'VSC',
  name: { en: 'Visual Studio Code Extensions', uk: 'Розширення Visual Studio Code' },
  entities: [
    { key: 'vsc', slug: 'vsc', name: { en: 'Visual Studio Code Extensions', uk: 'Розширення Visual Studio Code' }, main: true },
    { key: 'extension_definition_file', slug: 'extension-definition-file', name: { en: 'Extension Definition Files', uk: 'Файли визначень' }, main: false },
    { key: 'extension_snippet', slug: 'extension-snippet', name: { en: 'Extension Snippets', uk: 'Фрагменти коду' }, main: false },
    { key: 'extension_connection', slug: 'extension-connection', name: { en: 'Extension Connections', uk: 'Підключення' }, main: false },
  ],
  loadState: () => import('./state/visualStudioCodeExtensionsSlice').then((m) => m.visualStudioCodeExtensionsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
